{
  "clear": "Limpar",
  "invalid": "(inválido)",
  "loading": "A carregar...",
  "noResults": "Sem resultados"
}
